import buttonStyles from "@/styles/Button.module.scss";
import classnames from "classnames";
import { forwardRef } from "react";

// 連打を許可するボタン
const ButtonMultiClick = forwardRef((props, ref) => {
  const {
    className,
    fillColor,
    fillMainColor,
    fillGray,
    fillLightGray,
    fillCautionColor,
    fillTransparentGray,
    borderBlue,
    borderGray,
    borderLight,
    borderCaution,
    fontFixed,
    fontBold,
    large,
    medium,
    small,
    largeFont,
    favBtn,
    favBtnWithLabel,
    listRow,
    scale,
    inline,
    transparent,
    loading,
    hoverAnimation,
    bgColor,
    withIcon,
    disabledWithGray,
    ..._props
  } = props;

  return (
    <button
      ref={ref}
      className={classnames(buttonStyles.btn, className, {
        [buttonStyles.fillColor]: fillColor,
        [buttonStyles.fillMainColor]: fillMainColor,
        [buttonStyles.fillGray]: fillGray,
        [buttonStyles.fillLightGray]: fillLightGray,
        [buttonStyles.fillCautionColor]: fillCautionColor,
        [buttonStyles.fillTransparentGray]: fillTransparentGray,
        [buttonStyles.borderBlue]: borderBlue,
        [buttonStyles.borderGray]: borderGray,
        [buttonStyles.borderLight]: borderLight,
        [buttonStyles.borderCaution]: borderCaution,
        [buttonStyles.fontFixed]: fontFixed,
        [buttonStyles.fontBold]: fontBold,
        [buttonStyles.large]: large,
        [buttonStyles.medium]: medium,
        [buttonStyles.small]: small,
        [buttonStyles.largeFont]: largeFont,
        [buttonStyles.favBtn]: favBtn && !favBtnWithLabel,
        [buttonStyles.favBtnWithLabel]: favBtn && favBtnWithLabel,
        [buttonStyles.listRow]: listRow,
        [buttonStyles.scale]: scale,
        [buttonStyles.inline]: inline,
        [buttonStyles.transparent]: transparent,
        [buttonStyles.loading]: loading,
        [buttonStyles.hoverAnimation]: hoverAnimation,
        [buttonStyles.bgColor]: bgColor,
        [buttonStyles.withIcon]: withIcon,
        [buttonStyles.disabledWithGray]: disabledWithGray,
      })}
      {..._props}
    >
      {props.children}
    </button>
  );
});
ButtonMultiClick.displayName = "ButtonMultiClick";
export default ButtonMultiClick;
